import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
	ConstantsService,
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENTION
} from 'src/app/core/services/constant/constants.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { Address } from 'src/app/shared/models/address';
import * as L from 'leaflet';
@Component({
	selector: 'app-map',
	templateUrl: './map.component.html',
	styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {
	sessad_coord: number[] = [47.464436, -0.605093];
	sessad_name = 'Institut Montéclair';

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	/**
	 * Carte
	 */
	map: L.Map = null;

	/**
	 * Options de la carte
	 */
	options = {};

	/**
	 * Elements dessiner
	 */
	layers = [];

	/**
	 * Icone à afficher pour les centres
	 */
	 iconCentre = new L.Icon({
		iconUrl: 'node_modules/bootstrap-icons/icons/house-fill.svg',
		iconSize: [38, 95],
		iconAnchor: [22, 94],
		popupAnchor: [-3, -76],
		shadowSize: [68, 95],
		shadowAnchor: [22, 94]
	});

	/**
	 * Icone à afficher pour les missionPlaces
	 */
	iconMissionPlace = new L.Icon({
		iconUrl: 'node_modules/bootstrap-icons/icons/motarboard-fill.svg',
		iconSize: [38, 95],
		iconAnchor: [22, 94],
		popupAnchor: [-3, -76],
		shadowSize: [68, 95],
		shadowAnchor: [22, 94]
	});

	/**
	 * Icone à afficher pour les Beneficiaires
	 */
	iconBeneficiaire = new L.Icon({
		iconUrl: 'node_modules/bootstrap-icons/icons/person-fill.svg',
		iconSize: [38, 95],
		iconAnchor: [22, 94],
		popupAnchor: [-3, -76],
		shadowSize: [68, 95],
		shadowAnchor: [22, 94]
	});

	/**
	 * Option pour les marqueurs des elements dessiner
	 */
	markerOptionsCentre: L.MarkerOptions = {
		icon: this.iconCentre,
		draggable: false
	};

	markerOptionsMissionPlace: L.MarkerOptions = {
		icon: this.iconMissionPlace,
		draggable: false
	};

	markerOptionsBeneficiaire: L.MarkerOptions = {
		icon: this.iconBeneficiaire,
		draggable: false
	};

	labelBeneficiaire: string;
	labelIntervention: string;

	constructor(
		private constantsService: ConstantsService,
		private ref: ChangeDetectorRef,
		private logger: LogService,
		private facade: FacadeService,
		private dateUtils: DateUtils
	) {}

	ngOnInit(): void {
		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();
		const addressCenter: Address =
			this.facade.dataStorageService.getUser()?.employee.serviceCenter.address;
		this.sessad_name =
			this.facade.dataStorageService.getUser()?.employee.serviceCenter.name;
		this.sessad_coord = [addressCenter?.latitude, addressCenter?.longitude];
		this.options = {
			layers: [
				L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
					maxZoom: 18,
					attribution: '...'
				})
			],
			zoom: 15,
			center: L.latLng(this.sessad_coord[0], this.sessad_coord[1]),
			zoomControl: false
		};

		this.labelBeneficiaire = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_BENEFICIAIRE
		);
		this.labelIntervention = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);
	}

	getAndDrawData(): void {
		let missionsMarker: L.Marker[] = [];

		const sessadMarker = L.marker(
			[this.sessad_coord[0], this.sessad_coord[1]],
			this.markerOptionsCentre
		).bindPopup(`<p class="">${this.sessad_name}</p>`);
		this.layers.push(sessadMarker);
		this.map.addLayer(sessadMarker);

		if (!this.isSESSAD) {
			this.facade.beneficiaireService
				.getBeneficiairesMinimal()
				.subscribe((beneficiaires) => {
					beneficiaires.forEach((beneficiaire) => {
						if (
							beneficiaire.firstName &&
							beneficiaire.lastName &&
							beneficiaire.address &&
							beneficiaire.address.latitude &&
							beneficiaire.address.longitude
						) {
							missionsMarker.push(
								L.marker(
									[
										beneficiaire.address.latitude,
										beneficiaire.address.longitude
									],
									this.markerOptionsBeneficiaire
								).bindPopup(
									`<p class="">${
										beneficiaire.firstName + ' ' + beneficiaire.lastName
									}</p>`
								)
							);
						}
					});
					missionsMarker.forEach((missionMarker) => {
						this.layers.push(missionMarker);
						this.map.addLayer(missionMarker);
					});
				});
		} else {
			//Planning -> afficher les écoles

			this.facade.missionPlaceService
				.getMissionPlaces()
				.subscribe((missionPlaces) => {
					missionPlaces.forEach((missionPlace) => {
						if (
							(missionPlace.name || missionPlace.nameDisplay) &&
							missionPlace.address &&
							missionPlace.address.latitude &&
							missionPlace.address.longitude
						) {
							missionsMarker.push(
								L.marker(
									[
										missionPlace.address.latitude,
										missionPlace.address.longitude
									],
									this.markerOptionsMissionPlace
								).bindPopup(
									`<p class="">${
										missionPlace.nameDisplay
											? missionPlace.nameDisplay
											: missionPlace.name
									}</p>`
								)
							);
						}
					});
					missionsMarker.forEach((missionMarker) => {
						this.layers.push(missionMarker);
						this.map.addLayer(missionMarker);
					});
				});
		}
	}

	onMapReady(map) {
		this.map = map;
		this.initMap();
	}

	onClickCenter() {
		this.map.setView(
			new L.LatLng(this.sessad_coord[0], this.sessad_coord[1]),
			15
		);
	}

	onClickZoomIn() {
		this.map.zoomIn();
	}

	onClickZoomOut() {
		this.map.zoomOut();
	}

	/**
	 * Appel le nettoyage de la carte et le re-tracer des données
	 */
	initMap() {
		if (this.map) {
			this.cleanMap();
			this.getAndDrawData();
		}
	}

	/**
	 * Supprime les layers de la carte
	 */
	cleanMap() {
		if (this.map) {
			if (this.layers) {
				this.layers.forEach((layer) => this.map.removeLayer(layer));
				this.layers = [];
			}
		}
	}
}
